import { useApplicationLabels } from "~/hooks/useApplicationLabels";
import { createFileRoute } from "@tanstack/react-router";
import { queryClient, trpc } from "~/utils/trpc";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { ApplicationsTable } from "../-pages/applicationsTable";
import { FilterType } from "@quake/isomorphic";

const tableName = "recruitment_applications";
export const Route = createFileRoute("/_dashboard/$datasetSlug/data/applications/table/")({
  component: RouteComponent,
  loader: async () => {
    const tablePrefs = await queryClient.fetchQuery(trpc.users.getTablePreferences.queryOptions({ tableName }));
    return {
      initialDataFilters: tablePrefs.activePreferenceId
        ? tablePrefs.prefs.find((pref: any) => pref.id === tablePrefs.activePreferenceId)?.filters
        : tablePrefs.originalFilters,
      baseDataFilters: tablePrefs.originalFilters,

      initialColumnsDisplay: tablePrefs.activePreferenceId
        ? tablePrefs.prefs.find((pref: any) => pref.id === tablePrefs.activePreferenceId)?.columnsDisplay
        : tablePrefs.defaultColumnsDisplay,
      baseColumnsDisplay: tablePrefs.defaultColumnsDisplay,

      initialColumnsOrder: tablePrefs.activePreferenceId
        ? tablePrefs.prefs.find((pref: any) => pref.id === tablePrefs.activePreferenceId)?.columnsOrder
        : tablePrefs.defaultColumnsOrder,
      baseColumnsOrder: tablePrefs.defaultColumnsOrder,

      activeSort: tablePrefs.activePreferenceId
        ? tablePrefs.prefs.find((pref: any) => pref.id === tablePrefs.activePreferenceId)?.sort
        : [],

      activePreferenceId: tablePrefs.activePreferenceId,
    };
  },
});

function RouteComponent() {
  const { datasetSlug } = Route.useParams();
  const applicationTerm = useApplicationLabels();
  useBreadCrumbs([{ title: `${applicationTerm.plural} Table`, link: `/${datasetSlug}/data/applications/table` }]);
  const {
    initialDataFilters,
    baseDataFilters,
    initialColumnsOrder,
    initialColumnsDisplay,
    baseColumnsOrder,
    baseColumnsDisplay,
    activeSort,
    activePreferenceId,
  } = Route.useLoaderData();
  return (
    <ApplicationsTable
      initialDataFilters={initialDataFilters as Record<string, FilterType>}
      baseDataFilters={baseDataFilters}
      //
      initialColumnsDisplay={initialColumnsDisplay}
      baseColumnsDisplay={baseColumnsDisplay}
      //
      initialColumnsOrder={initialColumnsOrder}
      baseColumnsOrder={baseColumnsOrder}
      //
      activeSort={activeSort}
      activePreferenceId={activePreferenceId}
    />
  );
}
